module.exports = __webpack_public_path__ + "static/img/customer.89227d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/customer.jpg
// module id = IMaW
// module chunks = 1